import React, { useEffect, useState } from 'react';
import { FormGroup } from 'react-bootstrap';
import {components} from 'react-select';

import { useTranslate } from 'react-polyglot';
import 'react-toastify/dist/ReactToastify.css';
import './BookingResourceGuests.scss';
import Field from '../../../Shared/Wizard/Field/Field';

import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Grid, Tooltip, Switch } from '@material-ui/core';
import moment from 'moment';

function BookingResourceGuests(props) {
    const t = useTranslate();

    const [reload, setReload] = useState(0);
    const [doubleBookingChecked, setDoubleBookingChecked] = useState(false);

    const CustomOption = props => {
        let newChildren = <div>
            {props.data.data.organization != "" ?
                <p style={{ marginBottom: "0px", fontSize: "11px"}}>{props.data.data.organization}</p>
            : null}
            {props.data.data.email != "" || props.data.data.phone != "" ?
                <p style={{ marginBottom: "0px", fontSize: "11px"}}>{props.data.data.email + (props.data.data.email != "" && props.data.data.phone != "" ? " | " : "") + props.data.data.phone}</p>
            : null}
            {props.children}
            <hr style={{margin: "0px"}} />
        </div>;
        return (
            <div>
                <components.Option {...props} children={newChildren} />
            </div>
        );
    }

    function getBookedPeople(resource, bookingId) {
        let people: Array<any> = [];
        if (resource.bookings != undefined) {
            resource.bookings.forEach(booking => {
                if (booking.people != undefined && booking.bookingId == bookingId) {
                    booking.people.forEach(person => {
                        let foundPerson = props.people.find(p => p._id == person);
                        if (foundPerson != undefined && !people.map(i => i._id).includes(person)) {
                            people.push(foundPerson);
                        }
                    });
                }
            });
        }
        return people;
    }

    function getNonBookedPeople() {
        if (props.booking.guests != undefined && props.people.length != 0 && props.booking.resources != undefined) {
            let allPeople = props.people.filter(p => props.booking.guests.map(i => i._id).includes(p._id));
            let bookedPeople: Array<any> = [];
            
            getResources().forEach(resource => {
                let resourcePeople = getBookedPeople(resource, props.booking._id);
                resourcePeople.forEach(resourcePerson => {
                    bookedPeople.push(resourcePerson);
                });
            });

            return allPeople.filter(person => !bookedPeople.map(i => i._id).includes(person._id)).map(person => {
                let bookingPerson = props.booking?.guests?.find(p => p._id == person._id) ?? {};
                return {
                    ...person,
                    info: bookingPerson?.note ?? "",
                };
            });
        } else {
            return [];
        }
    }

    function updateResource(resource, val, bookingId) {
        let tempResources = props.resources;
        tempResources = tempResources.filter(r => r._id != resource._id);

        let tempBookings = resource.bookings;
        let tempBooking = tempBookings.find(b => b.bookingId == bookingId);
        tempBookings = tempBookings.filter(b => b.bookingId != bookingId);
        let people = tempBooking.people;

        if (tempBooking != undefined) {
            if (people == undefined) people = [];
            people = val.map(p => p.value);
            tempBooking.people = people;
        } else {
            tempBooking = {
                bookingId: bookingId,
                people: val.map(p => p.value),
                //eventId: event._id,
                //start: period.from,
                //end: period.to,
                uuid: uuidv4()
            };
        }
        tempBookings.push(tempBooking);

        resource.bookings = tempBookings;
        resource["changed"] = true;
        tempResources.push(resource);

        if (props.onResourcesChange != undefined) {
            props.onResourcesChange(JSON.parse(JSON.stringify(tempResources)));
        }

        setReload(reload + 1);
        
        localStorage.setItem("editedItems", "true");
    }

    function getResources() {
        let tempResources = props.resources.filter(r => props.booking.resources.map(i=>i.resource).includes(r._id));
        tempResources = _.orderBy(tempResources, ['name'], ['asc']);
        return tempResources;
    }

    // function toggleDoubleBookingShow(evt) {
    //     let doubleShow = !doubleBookingChecked;
    //     setDoubleBookingChecked(!doubleBookingChecked);
    // }
    
    useEffect(() => {
        
    }, []);

    return (
        <div style={{ marginTop: '30px'}} className="resourceguests">
            <h4 className="header-title">{t("booking.resourceguests.title")}</h4>
            <p>{t("booking.resourceguests.description")}</p>
            <div className="riskMatrixToggle" style={{height: "40px"}}>
                <FormGroup style={{width: "max-content"}}>
                    <Tooltip
                        title= {t("booking.doubletoggle_showtooltip")}
                        placement="right"
                    >
                        <Grid component="label" container alignItems="center" spacing={1} style={{float: "right"}}>
                            <Grid item>
                                <Switch
                                    size="small"
                                    checked={doubleBookingChecked}
                                    onChange={ evt => setDoubleBookingChecked(!doubleBookingChecked)}
                                    className={"toggleswitch"}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item>{t("booking.guests.doublebooking")}</Grid>
                        </Grid>
                    </Tooltip>
                </FormGroup>
            </div>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>{t("booking.resourceguests.tabletitle.resource")}</th>
                        <th>{t("booking.resourceguests.tabletitle.persons")}</th>
                    </tr>
                </thead>
                <tbody>
                    {props.booking.resources != undefined && props.booking.guests != undefined ?
                        getResources().map((resource,key) => 
                            <tr key={key}>
                                <td>{resource.name}</td>
                                <td style={{padding: "0px 8px"}}>
                                    {
                                        doubleBookingChecked != false ?
                                        <Field
                                            type="selectmulti"
                                            value={getBookedPeople(resource, props.booking._id).map(p => { return {label: p.lastname + ", " + p.firstname, value: p._id} })}
                                            options={{
                                                choices: props.people != undefined  ?
                                                    props.people.filter(p => props.booking.guests.map(i => i._id).includes(p._id)).map(p => {return {
                                                        label: p.lastname + ", " + p.firstname,
                                                        value: p._id,
                                                        data: p
                                                    }})
                                                : [],
                                                //choices: getGuestOptions,
                                                choosetext: t("booking.resourceguests.choosegueststext"),
                                                customOption: CustomOption
                                            }}
                                            onChange={(val) => {
                                                updateResource(resource, val, props.booking._id);
                                            }}
                                        ></Field>
                                        : 
                                        <Field
                                            type="selectmulti"
                                            value={getBookedPeople(resource, props.booking._id).map(p => { return {label: p.lastname + ", " + p.firstname, value: p._id} })}
                                            options={{
                                                choices: getNonBookedPeople().map((p,key) => {
                                                    return {
                                                        label: p.lastname + ", " + p.firstname,
                                                        value: p._id,
                                                        data: p
                                                    }}),
                                                //choices: getGuestOptions,
                                                choosetext: t("booking.resourceguests.choosegueststext"),
                                                customOption: CustomOption
                                            }}
                                            onChange={(val) => {
                                                updateResource(resource, val, props.booking._id);
                                            }}
                                        ></Field>
                                    }
                                    {getBookedPeople(resource, props.booking._id).map(guest => {
                                        let resourceBooking = resource.bookings.find(b => b.bookingId == props.booking._id);
                                        return <div className="row">
                                            <div className="col col-sm-6" style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexFlow: "column",
                                                paddingBottom: "18px",
                                                textAlign: "right"
                                            }}>
                                                <p style={{
                                                    height: "22px",
                                                    marginBottom: "0px"
                                                }}>{guest.lastname}, {guest.firstname}</p>
                                            </div>
                                            <div className="col col-sm-6 nobottommargin">
                                                <Field
                                                    type="selectmulti"
                                                    value={
                                                        resourceBooking.bookingtimes.filter(t => t.people?.includes(guest._id) ?? false).map(time => {
                                                            let start = moment(time.start);
                                                            let end = moment(time.end);
                                                            let diffYear = false;
                                                            if (start.get('year') != end.get('year')) {
                                                                diffYear = true;
                                                            }
                                                            return {
                                                                label: diffYear ? start.format("DD.MM.yyyy") + " -> " + end.format("DD.MM.yyyy") : start.format("DD.MM") + " - " + end.format("DD.MM"),
                                                                value: time.uuid
                                                            }
                                                        })
                                                    }
                                                    options={{
                                                        choosetext: t("booking.resourceguests.chooseperiodstext"),
                                                        choices: resourceBooking.bookingtimes.map(time => {
                                                            let start = moment(time.start);
                                                            let end = moment(time.end);
                                                            let diffYear = false;
                                                            if (start.get('year') != end.get('year')) {
                                                                diffYear = true;
                                                            }
                                                            return {
                                                                label: diffYear ? start.format("DD.MM.yyyy") + " -> " + end.format("DD.MM.yyyy") : start.format("DD.MM") + " - " + end.format("DD.MM"),
                                                                value: time.uuid
                                                            }
                                                        })
                                                    }}
                                                    onChange={(val) => {
                                                        for (let time of resourceBooking.bookingtimes) {
                                                            if (val.map(v => v.value).includes(time.uuid)) {
                                                                if (time.people == undefined) {
                                                                    time.people = [guest._id];
                                                                } else {
                                                                    if (!time.people.includes(guest._id)) {
                                                                        time.people.push(guest._id);
                                                                    }
                                                                }
                                                            } else {
                                                                if (time.people != undefined) {
                                                                    if (time.people.includes(guest._id)) {
                                                                        time.people.splice(time.people.indexOf(guest._id), 1);
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }}
                                                ></Field>
                                            </div>
                                        </div>
                                    })}
                                </td>
                            </tr>
                        )
                    : null}
                </tbody>
            </table>
            <p>{t("booking.resourceguests.guestsmissing") + ":"}</p>
            <div data-reload={reload}>
            <table style={{ width: "100%" }} className="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>{t("event.resourceGuests.guestList.table.name")}</th>
                            <th>{t("event.resourceGuests.guestList.table.notes")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getNonBookedPeople().map((guest, key) => 
                            <tr key={key}>
                                <td style={{ padding: "2px" }}>{guest.firstname + " " + guest.lastname}</td>
                                <td style={{ padding: "2px" }} dangerouslySetInnerHTML={{__html: guest.info}}></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default BookingResourceGuests;